var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D94141"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04105 4.14645C6.23632 4.34171 6.23632 4.65829 6.04105 4.85355L4.70711 6.1875H8.75C9.34674 6.1875 9.91903 6.42455 10.341 6.84651C10.7629 7.26847 11 8.02826 11 8.625V11.5C11 11.7761 10.7761 12 10.5 12C10.2239 12 10 11.7761 10 11.5V8.625C10 8.29348 9.8683 7.78804 9.63388 7.55362C9.39946 7.3192 9.08152 7.1875 8.75 7.1875H4.70711L6.04105 8.52145C6.23632 8.71671 6.23632 9.03329 6.04105 9.22855C5.84579 9.42382 5.52921 9.42382 5.33395 9.22855L3.14645 7.04105C2.95118 6.84579 2.95118 6.52921 3.14645 6.33395L5.33395 4.14645C5.52921 3.95118 5.84579 3.95118 6.04105 4.14645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturned);
export default __webpack_public_path__ + "static/media/returned.9b4ec7a5b5a5a6fff595ff9ec58bfd31.svg";
export { ForwardRef as ReactComponent };